import { Dialog, DialogContent, makeStyles } from "@material-ui/core";
import React from "react";
import { DialogTitle, Transition } from "../../../../utils/DialogTitle";
import { CreateUbicacion } from "../create/formCreateUbicacion";
import { EditUbicacion } from "../edit/formEditUbicacion";
import theme from "../../../../app/config/themaConfig";


const useStyles = makeStyles((theme) => ({
    title: {
        fontSize: '20px',
        backgroundColor: 'white',
        color: '#2196F3',
        padding: '16px',
        display: 'flex',
        justifyContent: 'Center',
        alignItems: 'center',
        fontWeight: 'bold'
    },
}));
const primaryColor = theme.palette.primary.main;

export const ModalUbicaciones = ({ busqueda, rowsPerPage, setopenMondal, isOpen, isEdit, data, reload, editUser }) => {

    const clearData = () => {
        setopenMondal(false)

    }
    const classes = useStyles();
    


    return (
        <>
            <div>
                <Dialog
                    onClose={(e) => { clearData() }}
                    aria-labelledby="customized-dialog-title"
                    open={isOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    style={{ maxHeight: "500%" }}
                    fullWidth={true}
                    maxWidth="sm"
                >
                    <DialogTitle id="customized-dialog-title" onClose={(e) => { clearData() }}className={classes.title} style={{color:primaryColor}} >
                        {isEdit ? `Editar Ubicacion` : `Crear Ubicacion`}
                    </DialogTitle>
                    <DialogContent style={{ paddingBottom: '30px' }}>
                        {
                            isEdit ?
                                (<EditUbicacion data={data} clearData={clearData} reload={reload} />)
                                :
                                (<CreateUbicacion create={reload} clearData={clearData} />)
                        }
                    </DialogContent>
                </Dialog>
            </div>
        </>
    );
}